/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  share: {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data:
      '<path pid="0" d="M25.313 20.625c-1.324 0-2.517.55-3.37 1.43L9.317 15.743a4.614 4.614 0 0 0 0-1.485l12.626-6.313A4.687 4.687 0 1 0 25.313 0a4.687 4.687 0 0 0-4.63 5.43L8.057 11.743a4.687 4.687 0 1 0 0 6.514l12.626 6.313a4.687 4.687 0 1 0 9.317.742 4.687 4.687 0 0 0-4.688-4.687" _fill="#000" fill-rule="evenodd"/>'
  }
})
